import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    height: 100%;
    box-sizing: border-box;
    background: #EEF1F6;
    /* padding + gap deixam o fundo cinza aparecer em volta e entre os cards */
    padding: 16px;
    gap: 16px;
`;

export const ListColumn = styled.div`
    flex: 0 0 360px;
    max-width: 360px;
    background: #FFFFFF;
    border-radius: 14px;
    overflow: hidden;
`;

export const ConversationColumn = styled.div`
    flex: 1;
    min-width: 0;
    background: #FFFFFF;
    border-radius: 14px;
    overflow: hidden;
`;

export const InfoColumn = styled.div`
    flex: 0 0 320px;
    max-width: 320px;
    background: #FFFFFF;
    border-radius: 14px;
    overflow: hidden;
`;
